import React, { Component } from "react";
import { connect } from "react-redux";
import { CloseCircle } from "iconsax-reactjs";

import { ShowVisibleNextAtd } from "../actions";

import { connection_platform } from "../services/api";
import Typography from "../components/Typography";

const mapStateToProps = (state) => {
  return {
    DisplayNextAtd: state.displaynextatd,
    DisplayDetails: state.displaydetailsatd,
    InfoUsers: state.informationusers,
    InfoDisplay: state.infodisplay,
    ContactId: state.atendimento,
    ServiceURL: state.serviceurl,
  };
};

const mapDispatchToProps = (dispatch) => ({
  ShowVisibleNextAtdIn: (post, temp) => {
    dispatch(ShowVisibleNextAtd(post, temp));
  },
});

class Crm extends Component {
  constructor(props) {
    super(props);
    this.state = { visible: "" };
  }

  CloseCrm() {
    this.props.ShowVisibleNextAtdIn(true, true);
  }

  render() {
    const {
      DisplayNextAtd,
      DisplayDetails,
      InfoUsers,
      InfoDisplay,
      ContactId,
      ServiceURL,
    } = this.props;

    let url_iframe = "";

    if (DisplayNextAtd.length != 0) {
      if (
        (DisplayNextAtd.displaynextatd === "ocultar" &&
          DisplayDetails.displaydetailsatd === true) ||
        DisplayDetails.displaydetailsatd === undefined
      ) {
        this.state.visible = " active w-40";
      } else if (
        DisplayNextAtd.displaynextatd === "ocultar" &&
        DisplayDetails.displaydetailsatd === false
      ) {
        this.state.visible = " active w-50";
      }
      if (
        DisplayNextAtd.displaynextatd === true ||
        DisplayNextAtd.displaynextatd === false
      )
        this.state.visible = "";
    }

    if (ServiceURL.length !== 0 && ContactId.length !== 0) {
      let ArrayServiceURL = "";

      if (InfoUsers.nameauth === "IngDesk") {
        ArrayServiceURL = ServiceURL.filter(
          (url) =>
            url.typeofcrm === "IngDesk" &&
            parseInt(ContactId.direction) === url.iddirection
        );
        if (ArrayServiceURL.length !== 0) {
          url_iframe = ArrayServiceURL[0].param;
        }
      } else if (InfoUsers.nameauth === "IngCeub") {
        ArrayServiceURL = ServiceURL.filter(
          (url) =>
            url.typeofcrm === "IngCeub" &&
            parseInt(ContactId.direction) === url.iddirection
        );
        if (ArrayServiceURL.length !== 0) {
          url_iframe = ArrayServiceURL[0].param;
        }
      } else {
        ArrayServiceURL = ServiceURL.filter(
          (url) =>
            url.typeofcrm === "URLExt" &&
            parseInt(ContactId.direction) === url.iddirection
        );
        if (ArrayServiceURL.length !== 0) {
          url_iframe = ArrayServiceURL[0].param;
        }
      }

      url_iframe = url_iframe.replace("${SYS.CDRID}", ContactId.idatendimento);
      url_iframe = url_iframe.replace(
        "${SYS.NUMEROCLIENTE}",
        ContactId.telefone
      );
      url_iframe = url_iframe.replace("${SYS.ATDID}", ContactId.serviceatd);
      url_iframe = url_iframe.replace("${SYS.LOGINAGENTE}", InfoUsers.email);
    }

    // url_iframe = "http://localhost:3000";

    if (InfoUsers.nameauth === "IngDesk") {
      return (
        <div
          className={"crm" + this.state.visible}
          style={{
            maxWidth: this.state.visible === " active w-40" ? "600px" : "650px",
          }}
        >
          <div
            className="crm__header"
            style={{ marginBottom: "0px" }}
            onClick={(event) => this.CloseCrm(event)}
          >
            <div className="crm__header__back">
              {" "}
              {/* <i className="material-icons">chevron_left</i> */}
              <CloseCircle color="#757575" />
              <Typography.H5 color={"gray-180"}>Fechar CRM</Typography.H5>
            </div>
          </div>
          <iframe
            frameBorder="0"
            allow="camera;microphone;clipboard-write"
            src={`${url_iframe}/externo/${
              ContactId.caseId ? "casos/" + ContactId.caseId : "criar-casos"
            }?login-master=ingenium&login-user=${
              InfoUsers.username
            }&password-master=52e9f8a1500604b372a5c0908d93ee5f&destination=${
              ContactId.telefone
            }&filters-allow=true`}
            style={{ height: "100%", width: "100%" }}
            name="iframe_a"
            title="Iframe Example"
          ></iframe>
        </div>
      );
    } else if (InfoUsers.nameauth === "IngCeub") {
      return (
        <div
          className={"crm" + this.state.visible}
          style={{
            maxWidth: this.state.visible === " active w-40" ? "600px" : "650px",
            width: "320px",
            minWidth: "320px",
          }}
        >
          <div
            className="crm__header"
            style={{ marginBottom: "0px" }}
            onClick={(event) => this.CloseCrm(event)}
          >
            <div className="crm__header__back">
              {" "}
              {/* <i className="material-icons">chevron_left</i> */}
              <CloseCircle color="#757575" />
              <Typography.H5 color={"gray-180"}>Fechar CRM</Typography.H5>
            </div>
          </div>
          <iframe
            frameBorder="0"
            allow="camera;microphone;clipboard-write"
            src={`${url_iframe}`}
            style={{ height: "100%", width: "100%" }}
            name="iframe_b"
            title="Iframe IngCeub"
          ></iframe>
        </div>
      );
    } else {
      return (
        // style={{maxWidth: this.state.visible === ' active w-40' ? '600px':'650px', width: '320px', minWidth: '320px'}}
        <div className={"crm" + this.state.visible}>
          <div
            className="crm__header"
            style={{ marginBottom: "0px" }}
            onClick={(event) => this.CloseCrm(event)}
          >
            <div className="crm__header__back">
              {" "}
              {/* <i className="material-icons">chevron_left</i> */}
              <CloseCircle color="#757575" />
              <Typography.H5 color={"gray-180"}>Fechar CRM</Typography.H5>
            </div>
          </div>
          <iframe
            frameBorder="0"
            allow="camera;microphone;clipboard-write"
            src={`${url_iframe}`}
            style={{ height: "100%", width: "100%" }}
            name="iframe_b"
            title="Iframe CRM"
          ></iframe>
        </div>
      );
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Crm);
